module.exports = __webpack_public_path__ + "img/segundavirginidad.2752f37b.jpg";